import pdfMake from "@digicole/pdfmake-rtl/build/pdfmake";
import pdfFonts from "@digicole/pdfmake-rtl/build/vfs_fonts";
import iransans from "../../assets/fonts/vazir/Farsi-Digits/Vazir-Light-FD.ttf";

var fontLoaded = false;

var loadFont = function () {
  if (fontLoaded) return Promise.resolve();
  pdfMake.vfs = pdfFonts;
  return fetch(iransans)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      var base64 = btoa(
        new Uint8Array(buf).reduce(function (data, byte) {
          return data + String.fromCharCode(byte);
        }, "")
      );
      pdfMake.vfs["IRANSansWeb.ttf"] = base64;
      pdfMake.fonts = {
        IRANSans: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
        Nillima: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
        Roboto: {
          normal: "IRANSansWeb.ttf",
          bold: "IRANSansWeb.ttf",
          italics: "IRANSansWeb.ttf",
          bolditalics: "IRANSansWeb.ttf",
        },
      };
      fontLoaded = true;
    });
};

export var generatePdf = function (columns, data, title, pdfName, orientation) {
  loadFont().then(function () {
    var filteredColumns = columns.filter(function (col) {
      return col.title !== "#";
    });

    var headerRow = [{ text: "#", style: "tableHeader", alignment: "center" }].concat(
      filteredColumns.map(function (col) {
        return {
          text: col.title,
          style: "tableHeader",
          alignment: "center",
        };
      })
    );

        var dataRows = data.map(function (rowData) {
      return [{ text: String(rowData.id || ""), alignment: "center" }].concat(
        filteredColumns.map(function (col) {
          var text = "";
          try {
            if (typeof col.pdfRender === "function") {
              text = String(col.pdfRender(rowData) || "");
            } else if (typeof col.render === "function") {
              var rendered = col.render(rowData);
              if (rendered && rendered.$$typeof) {
                var props = rendered.props || {};
                text = String(props.children || (props.value !== undefined ? props.value : "") || "");
              } else {
                text = String(rendered || "");
              }
            } else {
              text = String(rowData[col.field] || "");
            }
          } catch (e) {
            text = "";
          }
          return {
            text: text,
            alignment: "center",
          };
        })
      );
    });

    // var tableWidths = filteredColumns.map(function () {
    //   return "*";
    // });

    var docDefinition = {
      defaultStyle: {
        font: "IRANSans",
        fontSize: 10,
      },
      pageMargins: [25, 25, 25, 25],
      content: [
        {
          columns: [
            {
              width: "*",
              text: title,
              style: "title",
              alignment: "right",
            },
          ],
          margin: [0, 0, 0, 0],
        },
        {
          table: {
            headerRows: 1,
            // widths: tableWidths,
            body: [headerRow].concat(dataRows),
          },
          layout: {
            hLineWidth: function (i) {
              return i === 0 || i === 1 ? 1 : 0.5;
            },
            vLineWidth: function () {
              return 0.5;
            },
            hLineColor: function () {
              return "#cccccc";
            },
            vLineColor: function () {
              return "#cccccc";
            },
            fillColor: function (rowIndex) {
              return rowIndex === 0 ? "#01579b" : null;
            },
            paddingLeft: function () {
              return 5;
            },
            paddingRight: function () {
              return 5;
            },
            paddingTop: function () {
              return 2;
            },
            paddingBottom: function () {
              return 2;
            },
          },
        },
      ],
      styles: {
        title: {
          fontSize: 14,
          bold: true,
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
          color: "white",
        },
      },
      pageOrientation: orientation || "portrait",
    };

    pdfMake.createPdf(docDefinition).download(pdfName || "document.pdf");
  }).catch(function () {});
};

export default generatePdf;
